import { render, staticRenderFns } from "./master-details-component.vue?vue&type=template&id=4eee8a42&"
import script from "./master-details-component.vue?vue&type=script&lang=ts&"
export * from "./master-details-component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports